import React from 'react';
import { withFormik } from 'formik';
import { path, defaultTo } from 'ramda';

import { routes } from '../../routes';
import { apiResetPassword } from '../../api/user';
import { handleError } from '../../util/forms';

import Card from '../../components/Card';
import EditField from '../../components/Forms/EditField';

const ResetPassword = ({
  errors,
  touched,
  values,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  isValid,
  status,
}) => (
  <div className="col-md-8">
    <Card>
      <Card.Header>Reset Password</Card.Header>
      <Card.Body>
        <form>
          <EditField
            name="email"
            label="E-Mail Address"
            type="email"
            required
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
          />
          <EditField
            name="password"
            label="Password"
            type="password"
            required
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
          />
          <EditField
            name="passwordConfirmation"
            label="Confirm Password"
            type="password"
            required
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.passwordConfirmation}
          />
          <div className="form-group row mb-0">
            <div className="col-md-9 offset-md-3">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!isValid || isSubmitting}
                onClick={handleSubmit}
              >
                Reset Password
              </button>
            </div>
          </div>
        </form>
      </Card.Body>
    </Card>
  </div>
);

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;
    const token = path(['match', 'params', 'token'], props);
    let referrer;
    try {
      referrer = localStorage.getItem('referrer');
    } catch (err) {
      console.log(err);
    }
    const redirect = defaultTo(routes.dashboard, referrer);

    apiResetPassword({ ...payload, token })
      .then(() => (window.location.href = redirect))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: () => ({
    email: '',
    password: '',
    passwordConfirmation: '',
  }),
  isInitialValid: true,
  validateOnChange: true,
})(ResetPassword);
